(() => {
  if (typeof window.customElements.get('footer-site-switcher') !== 'undefined') { return }
  window.customElements.define('footer-site-switcher', class FooterSiteSwitcher extends HTMLElement {
    constructor () {
      super()

      this.dropdownEl = this.querySelector('[data-footer-site-switcher-dropdown]')

      this.initFooterSiteSwitcher()
    }

    initFooterSiteSwitcher () {
      try {
        this.initFooterSwitcherDropdown()
      } catch (error) {
        console.error('There was an issue with the Footer Site Switcher snippet:', error)
      }
    }

    initFooterSwitcherDropdown () {
      if (!this.dropdownEl) { return }

      this.dropdownEl.addEventListener('change', () => {
        window.location.href = this.dropdownEl.value
      })
    }
  })
})()
